import { render, staticRenderFns } from "./FavoritesList.vue?vue&type=template&id=3f569722&scoped=true&"
import script from "./FavoritesList.vue?vue&type=script&lang=js&"
export * from "./FavoritesList.vue?vue&type=script&lang=js&"
import style0 from "./FavoritesList.vue?vue&type=style&index=0&id=3f569722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f569722",
  null
  
)

/* custom blocks */
import block0 from "./FavoritesList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports